<template>
  <div class="skeleton">
    <div
      :style="setHeight"
      v-for="i in amount"
      :key="i"
      class="skeleton__block"
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    amount: {
      type: Number,
      default: 1
    },
    height: {
      type: Number,
      default: 20
    },
    unit: {
      type: String,
      default: "px"
    }
  },
  data() {
    return {};
  },
  computed: {
    setHeight() {
      return "height: " + this.height.toString() + this.unit;
    }
  },
  methods: {}
};
</script>
<style scoped lang="scss">
@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.skeleton {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 18px;
  background: transparent;
  &__block {
    background: linear-gradient(90deg, #1e1e2f 25%, #28283f 37%, #1e1e2f 63%);
    background-size: 400% 100%;
    height: 45px;
    width: 100%;
    animation: skeleton-loading 1.4s ease infinite;
  }
}
</style>
